module.exports = __webpack_public_path__ + "img/seo.3a8fca64.svg";